import { PHONE_DISPLAY, PHONE_TEL, EMAIL, ADDRESS_FULL, HOURS_LABEL } from '../../../lib/businessInfo';

export default function ContactInfo() {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-[#E8E2D6] p-5 sm:p-8">
      <h2 className="text-xl sm:text-2xl font-bold text-[#1A2332] mb-5 sm:mb-6">Get in Touch</h2>

      <div className="space-y-5 sm:space-y-6">
        <div className="flex items-start gap-3 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F0FDF9] rounded-lg flex items-center justify-center flex-shrink-0" aria-hidden="true">
            <i className="ri-phone-line text-xl sm:text-2xl text-[#0d6b5e]"></i>
          </div>
          <div className="min-w-0">
            <h3 className="font-semibold text-[#1A2332] mb-1 text-sm sm:text-base">Phone</h3>
            <a
              href={`tel:${PHONE_TEL}`}
              className="text-[#0d6b5e] hover:text-[#0a5549] transition-colors font-medium underline underline-offset-2 text-sm sm:text-base"
            >
              {PHONE_DISPLAY}
            </a>
          </div>
        </div>

        <div className="flex items-start gap-3 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F0FDF9] rounded-lg flex items-center justify-center flex-shrink-0" aria-hidden="true">
            <i className="ri-mail-line text-xl sm:text-2xl text-[#0d6b5e]"></i>
          </div>
          <div className="min-w-0">
            <h3 className="font-semibold text-[#1A2332] mb-1 text-sm sm:text-base">Email</h3>
            <a
              href={`mailto:${EMAIL}`}
              className="text-[#0d6b5e] hover:text-[#0a5549] transition-colors font-medium break-all underline underline-offset-2 text-sm sm:text-base"
            >
              {EMAIL}
            </a>
          </div>
        </div>

        <div className="flex items-start gap-3 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F0FDF9] rounded-lg flex items-center justify-center flex-shrink-0" aria-hidden="true">
            <i className="ri-map-pin-line text-xl sm:text-2xl text-[#0d6b5e]"></i>
          </div>
          <div className="min-w-0">
            <h3 className="font-semibold text-[#1A2332] mb-1 text-sm sm:text-base">Address</h3>
            <p className="text-[#374151] text-sm sm:text-base break-words">{ADDRESS_FULL}</p>
          </div>
        </div>

        <div className="flex items-start gap-3 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F0FDF9] rounded-lg flex items-center justify-center flex-shrink-0" aria-hidden="true">
            <i className="ri-time-line text-xl sm:text-2xl text-[#0d6b5e]"></i>
          </div>
          <div className="min-w-0">
            <h3 className="font-semibold text-[#1A2332] mb-1 text-sm sm:text-base">Hours</h3>
            <p className="text-[#374151] text-sm sm:text-base">{HOURS_LABEL}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
